export default __webpack_public_path__ + "static/media/Signature-Black.82da9e8a.jpg";